import { defineStore } from 'pinia'

const useBranchStore = defineStore('branch', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default useBranchStore
